import type { ChordHubProgress } from "./chordHubTypes";

const STORAGE_KEY = "bordona-chord-hub-progress";

export const defaultChordHubProgress: ChordHubProgress = {
  completedCardIds: [],
  completedAt: {},
};

export function loadChordHubProgress(): ChordHubProgress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultChordHubProgress;
    const p = JSON.parse(raw) as Partial<ChordHubProgress>;
    return {
      completedCardIds: Array.isArray(p.completedCardIds) ? p.completedCardIds : [],
      completedAt: p.completedAt && typeof p.completedAt === "object" ? p.completedAt : {},
    };
  } catch {
    return defaultChordHubProgress;
  }
}

export function saveChordHubProgress(progress: ChordHubProgress): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch {
    /* quota */
  }
}

export function markChordHubCardComplete(
  progress: ChordHubProgress,
  cardId: string
): ChordHubProgress {
  const completedCardIds = progress.completedCardIds.includes(cardId)
    ? progress.completedCardIds
    : [...progress.completedCardIds, cardId];
  return {
    completedCardIds,
    completedAt: { ...progress.completedAt, [cardId]: Date.now() },
  };
}
